'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layoutStyles = exports.alignRight = exports.alignTop = exports.alignLeft = exports.overflowImageContainer = exports.centerHorizontal = exports.centerVertical = exports.containerWithoutBottomPadding = exports.containerWithoutTopPadding = exports.defaultContainerProperties = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _defaultContainerProp, _containerWithoutTopP, _containerWithoutBott;

var _aphrodite = require('aphrodite');

var _mediaQuery = require('./mediaQuery');

var _mediaQuery2 = _interopRequireDefault(_mediaQuery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // to be used with top-level sections of landing pages
// scales horizontal whitespace between edge of screen top-level section content
// scales vertical whitespace between different top-level section content


var defaultContainerProperties = exports.defaultContainerProperties = (_defaultContainerProp = {
  boxSizing: 'border-box',
  padding: '72px 102px'
}, _defineProperty(_defaultContainerProp, _mediaQuery2.default.maxWidth.desktop, {
  padding: '72px 40px'
}), _defineProperty(_defaultContainerProp, _mediaQuery2.default.maxWidth.tablet, {
  padding: '48px 40px'
}), _defineProperty(_defaultContainerProp, _mediaQuery2.default.maxWidth.mobileLarge, {
  padding: '32px 16px'
}), _defaultContainerProp); // to be used for top-level sections that follow an overflow image that has negative margins
// this is a common pattern on the homepage
// this can't inherit from defaultContainerProperties due to mixed media queries
// could be reconciled if we rebuilt these as Maps objects (see Aphrodite README for more)

var containerWithoutTopPadding = exports.containerWithoutTopPadding = (_containerWithoutTopP = {
  boxSizing: 'border-box',
  padding: '0 72px 102px 72px'
}, _defineProperty(_containerWithoutTopP, _mediaQuery2.default.maxWidth.desktop, {
  padding: '0 40px 72px 40px'
}), _defineProperty(_containerWithoutTopP, _mediaQuery2.default.maxWidth.tablet, {
  padding: '0 40px 48px 40px'
}), _defineProperty(_containerWithoutTopP, _mediaQuery2.default.maxWidth.mobileLarge, {
  padding: '0 16px 32px 16px'
}), _containerWithoutTopP);
var containerWithoutBottomPadding = exports.containerWithoutBottomPadding = (_containerWithoutBott = {
  boxSizing: 'border-box',
  padding: '102px 72px 0 72px'
}, _defineProperty(_containerWithoutBott, _mediaQuery2.default.maxWidth.desktop, {
  padding: '72px 40px 0 40px'
}), _defineProperty(_containerWithoutBott, _mediaQuery2.default.maxWidth.tablet, {
  padding: '48px 40px 0 40px'
}), _defineProperty(_containerWithoutBott, _mediaQuery2.default.maxWidth.mobileLarge, {
  padding: '32px 16px 0 16px'
}), _containerWithoutBott); // centerVertical will break in IE11 when used on containers with `flex-direction: column`
// follow the link for available workarounds: https://github.com/philipwalton/flexbugs#flexbug-2

var centerVertical = exports.centerVertical = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  alignContent: 'center'
};
var centerHorizontal = exports.centerHorizontal = {
  display: 'flex',
  flexDirection: 'row',
  justifyItems: 'center',
  justifyContent: 'center'
};

var overflowImageContainer = exports.overflowImageContainer = _extends({}, centerVertical, centerHorizontal, {
  width: '100vw',
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw'
});

var alignLeft = exports.alignLeft = {
  display: 'flex',
  flexDirection: 'row',
  justifyItems: 'flex-start',
  justifyContent: 'flex-start'
};
var alignTop = exports.alignTop = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  alignContent: 'flex-start'
};
var alignRight = exports.alignRight = {
  display: 'flex',
  flexDirection: 'row',
  justifyItems: 'flex-end',
  justifyContent: 'flex-end'
};

var layoutStyles = exports.layoutStyles = _aphrodite.StyleSheet.create({
  defaultContainerProperties: defaultContainerProperties,
  containerWithoutTopPadding: containerWithoutTopPadding,
  overflowImageContainer: overflowImageContainer,
  centerVertical: centerVertical,
  centerHorizontal: centerHorizontal,
  alignRight: alignRight,
  alignLeft: alignLeft
});

exports.default = layoutStyles;